import Profile from '@/features/user/Profile';
import Dashboard from '@/features/dashboard/Dashboard';
import CalledList from '@/features/called/CalledList';
import CalledForm from '@/features/called/CalledForm';
import EventList from '@/features/event/EventList';
import EventForm from '@/features/event/EventForm';
import FollowCalled from '@/features/follow-called/FollowCalled';
import CycleConsolidated from '@/features/report/CycleConsolidated';
import UserProjectList from '@/features/user-project/UserProjectList';
import UserProjectForm from '@/features/user-project/UserProjectForm';

export default [
  {
    path: 'pofile',
    name: 'profile',
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: '',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: 'called',
    name: 'called-list',
    component: CalledList,
    meta: { requiresAuth: true },
  },
  {
    path: 'called/:id',
    name: 'called-form',
    component: CalledForm,
    meta: { requiresAuth: true },
  },
  {
    path: 'event',
    name: 'event-list',
    component: EventList,
    meta: { requiresAuth: true },
  },
  {
    path: 'event/:id',
    name: 'event-form',
    component: EventForm,
    meta: { requiresAuth: true },
  },
  {
    path: 'follow-called/:id',
    name: 'follow-called',
    component: FollowCalled,
    meta: { requiresAuth: true },
  },
  {
    path: 'report',
    name: 'cycle-consolidated',
    component: CycleConsolidated,
    meta: { requiresAuth: true },
  },
  {
    path: 'user-project',
    name: 'user-project-list',
    component: UserProjectList,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente', 'analista'] },
  },
  {
    path: 'user-project/:id',
    name: 'user-project-form',
    component: UserProjectForm,
    meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente', 'analista'] },
  },
];



// WEBPACK FOOTER //
// ./src/router/AuthenticatedRoutes.js